import styled from 'styled-components';

import { styledInteraction, styledLayout } from '@pkg/primitives';

// TODO: This is required until we refactor our
// <Chip /> component, which currently forces
// interaction styling even when it isn't interactive.
// TODO: We may want to always apply `fullWidthFix` to `Chip`.
export const HackChipWrapper = styled.div`
    ${styledInteraction.interactionDisable};
    ${styledLayout.fullWidthFix};
`;
